import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bac2da2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "message_wrap" }
const _hoisted_2 = {
  key: 0,
  class: "message_main to_right"
}
const _hoisted_3 = { class: "message_content" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "message_txt message_img"
}
const _hoisted_6 = { class: "message_avatar" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "message_main"
}
const _hoisted_9 = { class: "message_avatar" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "message_content" }
const _hoisted_12 = { class: "user_name" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 1,
  class: "message_txt message_img"
}

import { reactive } from 'vue';
import { ElImage } from 'element-plus';
import { PrivateChatView } from '@/pinia/types/console';

interface Props {
  sourceData: PrivateChatView;
  self: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatMessage',
  props: {
    sourceData: null,
    self: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  sourceData: PrivateChatView;
  self: boolean;
};

const elImage = ElImage;


const data = reactive(props.sourceData);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (props.self)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            (data.msg_type === 'txt')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "message_txt content",
                  innerHTML: data.content
                }, null, 8, _hoisted_4))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(elImage), {
                    src: data?.image_content_url,
                    "preview-src-list": [data.image_content_url as string],
                    "hide-on-click-modal": ""
                  }, null, 8, ["src", "preview-src-list"])
                ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: data.avatar_url,
              alt: ""
            }, null, 8, _hoisted_7)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: data.avatar_url,
              alt: ""
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, _toDisplayString(data.nickname), 1)
            ]),
            (data.msg_type === 'txt')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "message_txt content",
                  innerHTML: data.content
                }, null, 8, _hoisted_14))
              : (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_unref(elImage), {
                    src: data?.image_content_url,
                    "preview-src-list": [data.image_content_url as string],
                    "hide-on-click-modal": ""
                  }, null, 8, ["src", "preview-src-list"])
                ]))
          ])
        ]))
  ]))
}
}

})